import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { Typography } from '../../typography-voery/Typography';
import { ListContext } from './context';
import { ListOption } from './ListOption';

interface ListProps {
  title?: string;
  options: string[];
  defaultValue?: string;
  onChange: (value: string) => void;
  children?: React.ReactNode;
}

export const List: React.FC<ListProps> = ({
  title,
  options,
  defaultValue = '',
  onChange,
  children,
}) => {
  const [currentValue, setCurrentValue] = useState(defaultValue);

  useEffect(() => {
    setCurrentValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (value: string) => {
    setCurrentValue(value);
    onChange(value);
  };

  return (
    <div className={styles.list}>
      {title && (
        <Typography variant='body-bold' className={styles.listTitle}>
          {title}
        </Typography>
      )}
      <div className={styles.listItems}>
        <ListContext.Provider value={{ handleChange, currentValue }}>
          {children ||
            options.map((option, index) => (
              <ListOption key={index} value={option}>
                {option}
              </ListOption>
            ))}
        </ListContext.Provider>
      </div>
    </div>
  );
};
